//  import CommonSelect from './src/common-select';
//  export default CommonSelect;
export default window._rhinoComponents.CommonSelect;
